export const CHANNEL_MAP = {
  "ABolaTV.pt": "A Bola TV",
  "DAZN1.uk@Portugal": "DAZN 1",
  "DAZN2.uk@Portugal": "DAZN 2",
  "DAZN3.uk@Portugal": "DAZN 3",
  "DAZN4.uk@Portugal": "DAZN 4",
  "DAZN5.uk@Portugal": "DAZN 5",
  "DAZN6.uk@Portugal": "DAZN 6",
  "EURHD": "Eurosport 1",
  "EURS2HD": "Eurosport 2",
  "FightSports.us": "Fight Sports",
  "NBATV.us": "NBA TV",
  "PortoCanal.pt": "Porto Canal",
  "RTP1.pt": "RTP 1",
  "RTP2.pt": "RTP 2",
  "RTP3.pt": "RTP 3",
  "SCPHD": "Sporting TV",
  "SIC.pt": "SIC",
  "SLBHD": "BTV",
  "SPT1HD": "Sport TV1",
  "SPT2HD": "Sport TV2",
  "SPT3HD": "Sport TV3",
  "SPT4HD": "Sport TV4",
  "SPT5HD": "Sport TV5",
  "SPT6HD": "Sport TV6",
  "SPT7HD": "Sport TV7",
  "SPTVHD": "Sport TV+",
  "TVI.pt": "TVI",
  "TVIFiccao.pt": "TVI Ficcao",
  "WSPORT": "W-Sport",
  "XSport.ua": "XSport"
}; 